/**
 * Converts a File object to a base64 string
 * @param file - The File object to convert
 * @param keepPrefix - Whether to keep the MIME type prefix (default: false)
 * @returns Promise containing the base64 string
 */
export const fileToBase64 = (file: File, keepPrefix: boolean = false): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result as string;
      if (keepPrefix) {
        // Return the full base64 string with MIME type prefix
        resolve(result);
      } else {
        // Remove the data:image/jpeg;base64, prefix to get just the base64 string
        const base64String = result.split(',')[1];
        resolve(base64String);
      }
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};
